import { FilterGroupOperator, } from 'pe-core-frontend';
export var ReturnEntityType;
(function (ReturnEntityType) {
    ReturnEntityType["EMPLOYEE"] = "employee";
    ReturnEntityType["PROGRAM"] = "program";
})(ReturnEntityType || (ReturnEntityType = {}));
export var ExportEntityType;
(function (ExportEntityType) {
    ExportEntityType["EMPLOYEE"] = "employee";
    ExportEntityType["PROGRAM"] = "program";
    ExportEntityType["PAYROLL_PAYMENT"] = "payroll_payment";
    ExportEntityType["PAYROLL_ITEM"] = "payroll_item";
})(ExportEntityType || (ExportEntityType = {}));
export var EntityType;
(function (EntityType) {
    EntityType["FILTER_EMPLOYEE"] = "filter_employee";
    EntityType["EMPLOYEE"] = "employee";
    EntityType["PROGRAM"] = "program";
    EntityType["PAYMENT_REQUEST"] = "payment_request";
    EntityType["PAYMENT_REQUEST_ITEM"] = "payment_request_item";
    EntityType["PAYROLL_ITEM"] = "payroll_item";
    EntityType["PAYROLL_PAYMENT"] = "payroll_payment";
})(EntityType || (EntityType = {}));
export var EligPopulationEntityType;
(function (EligPopulationEntityType) {
    EligPopulationEntityType["FILTER_EMPLOYEE"] = "filter_employee";
    EligPopulationEntityType["EMPLOYEE"] = "employee";
    EligPopulationEntityType["PROGRAM"] = "program";
})(EligPopulationEntityType || (EligPopulationEntityType = {}));
export var BenefitPeriodPopulationEntityType;
(function (BenefitPeriodPopulationEntityType) {
    BenefitPeriodPopulationEntityType["FILTER_EMPLOYEE"] = "filter_employee";
    BenefitPeriodPopulationEntityType["EMPLOYEE"] = "employee";
})(BenefitPeriodPopulationEntityType || (BenefitPeriodPopulationEntityType = {}));
export var EmployeePopulationEntityType;
(function (EmployeePopulationEntityType) {
    EmployeePopulationEntityType["FILTER_EMPLOYEE"] = "filter_employee";
    EmployeePopulationEntityType["EMPLOYEE"] = "employee";
})(EmployeePopulationEntityType || (EmployeePopulationEntityType = {}));
export var PointInTimeEligPopulationEntityType;
(function (PointInTimeEligPopulationEntityType) {
    PointInTimeEligPopulationEntityType["EMPLOYEE"] = "employee";
})(PointInTimeEligPopulationEntityType || (PointInTimeEligPopulationEntityType = {}));
export var PopulationEntityType;
(function (PopulationEntityType) {
    PopulationEntityType["FILTER_EMPLOYEE"] = "filter_employee";
    PopulationEntityType["EMPLOYEE"] = "employee";
    PopulationEntityType["PROGRAM"] = "program";
})(PopulationEntityType || (PopulationEntityType = {}));
export var PopulationEntityPaymentRequestType;
(function (PopulationEntityPaymentRequestType) {
    PopulationEntityPaymentRequestType["FILTER_EMPLOYEE"] = "filter_employee";
    PopulationEntityPaymentRequestType["EMPLOYEE"] = "employee";
    PopulationEntityPaymentRequestType["PROGRAM"] = "program";
    PopulationEntityPaymentRequestType["PAYMENT_REQUEST"] = "payment_request";
})(PopulationEntityPaymentRequestType || (PopulationEntityPaymentRequestType = {}));
export var ProgramEntityType;
(function (ProgramEntityType) {
    ProgramEntityType["PROGRAM"] = "program";
})(ProgramEntityType || (ProgramEntityType = {}));
export var EmployeeStatus;
(function (EmployeeStatus) {
    EmployeeStatus["ACTIVE"] = "ACTIVE";
    EmployeeStatus["TERMINATED"] = "TERMINATED";
    EmployeeStatus["SUSPENDED"] = "SUSPENDED";
    EmployeeStatus["ON_LEAVE"] = "ON_LEAVE";
    EmployeeStatus["DECEASED"] = "DECEASED";
    EmployeeStatus["RETIRED"] = "RETIRED";
})(EmployeeStatus || (EmployeeStatus = {}));
export var EmploymentStatus;
(function (EmploymentStatus) {
    EmploymentStatus["FULL_TIME"] = "FULL_TIME";
    EmploymentStatus["PART_TIME"] = "PART_TIME";
    EmploymentStatus["TEMPORARY"] = "TEMPORARY";
    EmploymentStatus["CONTRACT"] = "CONTRACT";
    EmploymentStatus["SEASONAL"] = "SEASONAL";
    EmploymentStatus["INTERNSHIP"] = "INTERNSHIP";
    EmploymentStatus["APPRENTICESHIP"] = "APPRENTICESHIP";
    EmploymentStatus["VOLUNTEER"] = "VOLUNTEER";
    EmploymentStatus["INDEPENDENT_CONTRACTOR"] = "INDEPENDENT_CONTRACTOR";
    EmploymentStatus["FREELANCER"] = "FREELANCER";
    EmploymentStatus["CONSULTANT"] = "CONSULTANT";
    EmploymentStatus["PER_DIEM"] = "PER_DIEM";
    EmploymentStatus["DAY_LABORER"] = "DAY_LABORER";
})(EmploymentStatus || (EmploymentStatus = {}));
export var EligibilityStatus;
(function (EligibilityStatus) {
    EligibilityStatus["ELIGIBLE"] = "ELIGIBLE";
    EligibilityStatus["INELIGIBLE"] = "INELIGIBLE";
})(EligibilityStatus || (EligibilityStatus = {}));
export var RuleType;
(function (RuleType) {
    RuleType["ELIGIBILITY"] = "eligibility";
    RuleType["FUNDING"] = "funding";
    RuleType["BUDGET"] = "budget";
    RuleType["ACADEMIC"] = "academic";
    RuleType["CLAWBACK"] = "clawback";
    RuleType["PROGRAM"] = "program";
    RuleType["FIELD_OF_STUDY"] = "field_of_study";
    RuleType["PAYMENT_REQUEST"] = "payment_request";
    RuleType["APPROVAL_CHAIN"] = "approval_chain";
    RuleType["SCHOOL"] = "school";
    RuleType["EXPENSE"] = "expense";
    RuleType["POINT_IN_TIME_ELIGIBILITY"] = "point_in_time_eligibility";
    RuleType["TERMINATION"] = "termination";
})(RuleType || (RuleType = {}));
export var TaxableType;
(function (TaxableType) {
    TaxableType["LIMIT"] = "limit";
    TaxableType["EXEMPT"] = "exempt";
    TaxableType["TAXED"] = "taxed";
})(TaxableType || (TaxableType = {}));
export var WorkflowType;
(function (WorkflowType) {
    WorkflowType["PROGRAM_APPROVAL"] = "program_approval";
    WorkflowType["PAYMENT_REQUEST_APPROVAL"] = "payment_request_approval";
    // APPEAL_PROGRAM = 'appeal_program',
    // APPEAL_PAYMENT_REQUEST = 'appeal_payment_request',
    // APPEAL_PAYMENT = 'appeal_payment',
    WorkflowType["PREIMBURSEMENT_APPROVAL"] = "preimbursement_approval";
    WorkflowType["BUDGET_APPROVAL"] = "budget_approval";
    WorkflowType["OTHER_SCHOOL_APPROVAL"] = "other_school_approval";
})(WorkflowType || (WorkflowType = {}));
export var PaymentRequestAnchorDateType;
(function (PaymentRequestAnchorDateType) {
    PaymentRequestAnchorDateType["CREATED_DATE"] = "CREATED_DATE";
    PaymentRequestAnchorDateType["SUBMITTED_DATE"] = "SUBMITTED_DATE";
    PaymentRequestAnchorDateType["DOCUMENT_SUBMISSION_DATE"] = "DOCUMENT_SUBMISSION_DATE";
    PaymentRequestAnchorDateType["TERM_START_DATE"] = "TERM_START_DATE";
    PaymentRequestAnchorDateType["TERM_END_DATE"] = "TERM_END_DATE";
    PaymentRequestAnchorDateType["APPROVED_DATE"] = "APPROVED_DATE";
})(PaymentRequestAnchorDateType || (PaymentRequestAnchorDateType = {}));
export var BudgetApprovalMode;
(function (BudgetApprovalMode) {
    BudgetApprovalMode["ALWAYS_AUTO"] = "ALWAYS_AUTO";
    BudgetApprovalMode["ALWAYS_MANUAL"] = "ALWAYS_MANUAL";
    BudgetApprovalMode["AUTO_THEN_MANUAL"] = "AUTO_THEN_MANUAL";
})(BudgetApprovalMode || (BudgetApprovalMode = {}));
export var BudgetSwitchCriteriaType;
(function (BudgetSwitchCriteriaType) {
    BudgetSwitchCriteriaType["PERCENTAGE"] = "PERCENTAGE";
    BudgetSwitchCriteriaType["AMOUNT"] = "AMOUNT";
})(BudgetSwitchCriteriaType || (BudgetSwitchCriteriaType = {}));
export var AcademicPolicyType;
(function (AcademicPolicyType) {
    // these are in lower case to match the enum value in the backend
    AcademicPolicyType["GRADE"] = "grade";
    AcademicPolicyType["CGPA"] = "cgpa";
})(AcademicPolicyType || (AcademicPolicyType = {}));
export var DeadlineDateType;
(function (DeadlineDateType) {
    DeadlineDateType["START_DATE"] = "start_date";
    DeadlineDateType["END_DATE"] = "end_date";
})(DeadlineDateType || (DeadlineDateType = {}));
export var SchoolOption;
(function (SchoolOption) {
    SchoolOption["PROVIDER"] = "provider";
    SchoolOption["SCHOOL"] = "school";
})(SchoolOption || (SchoolOption = {}));
export var OtherOption;
(function (OtherOption) {
    /**
     * Allow user to enter a school/field of study that is not in the list
     */
    OtherOption["ALLOW"] = "allow";
    /**
     * Warn user that approval is needed if other option is selected
     */
    OtherOption["WARN"] = "warn";
    /**
     * Don't allow other option
     */
    OtherOption["DISALLOW"] = "disallow";
})(OtherOption || (OtherOption = {}));
export var PointInTimeDateOperator;
(function (PointInTimeDateOperator) {
    PointInTimeDateOperator["ON"] = "on";
    // BETWEEN = 'between', // TODO: Implement in future if needed
})(PointInTimeDateOperator || (PointInTimeDateOperator = {}));
export var PointInTimeEvaluateOption;
(function (PointInTimeEvaluateOption) {
    PointInTimeEvaluateOption["SNAPSHOT"] = "snapshot";
    PointInTimeEvaluateOption["CURRENT"] = "current";
})(PointInTimeEvaluateOption || (PointInTimeEvaluateOption = {}));
export var PointInTimeDateField;
(function (PointInTimeDateField) {
    PointInTimeDateField["START_DATE"] = "start_date";
    PointInTimeDateField["END_DATE"] = "end_date";
    PointInTimeDateField["SPECIFIC_DATE"] = "specific_date";
})(PointInTimeDateField || (PointInTimeDateField = {}));
export var EmailContentCode;
(function (EmailContentCode) {
    // Email to employees
    EmailContentCode["RESET_PASSWORD"] = "reset_password";
    EmailContentCode["SIGN_UP"] = "sign_up";
    EmailContentCode["MFA_CODE"] = "mfa_code";
    // Program request
    EmailContentCode["PROGRAM_APPROVED"] = "program_approved";
    EmailContentCode["PROGRAM_REJECTED"] = "program_rejected";
    EmailContentCode["PROGRAM_INFO_NEEDED"] = "program_info_needed";
    EmailContentCode["PROGRAM_EXPIRED"] = "program_expired";
    // Payment request pre-approval
    EmailContentCode["PAYMENT_REQUEST_APPROVED"] = "payment_request_approved";
    EmailContentCode["PAYMENT_REQUEST_REJECTED"] = "payment_request_rejected";
    EmailContentCode["PAYMENT_REQUEST_INFO_NEEDED"] = "payment_request_info_needed";
    // Preimbursement Payment request pre-approval
    EmailContentCode["PAYMENT_REQUEST_APPROVED_PREIMBURSEMENT"] = "payment_request_approved_preimbursement";
    EmailContentCode["PAYMENT_REQUEST_REJECTED_PREIMBURSEMENT"] = "payment_request_rejected_preimbursement";
    EmailContentCode["PAYMENT_REQUEST_INFO_NEEDED_PREIMBURSEMENT"] = "payment_request_info_needed_preimbursement";
    // Payment reimbursement request
    EmailContentCode["PAYMENT_APPROVED"] = "payment_approved";
    EmailContentCode["PAYMENT_REJECTED"] = "payment_rejected";
    EmailContentCode["PAYMENT_INFO_NEEDED"] = "payment_info_needed";
    // Emails to approvers
    EmailContentCode["PROGRAM_APPROVAL_TO_APPROVER"] = "program_approval_to_approver";
    EmailContentCode["PROGRAM_REPLIED_INFO_NEEDED_TO_APPROVER"] = "program_replied_info_needed_to_approver";
    EmailContentCode["OTHER_SCHOOL_APPROVAL_TO_APPROVER"] = "other_school_approval_to_approver";
    EmailContentCode["PAYMENT_REQUEST_APPROVAL_TO_APPROVER"] = "payment_request_approval_to_approver";
    EmailContentCode["PAYMENT_REQUEST_REPLIED_INFO_NEEDED_TO_APPROVER"] = "payment_request_replied_info_needed_to_approver";
    EmailContentCode["PAYMENT_REQUEST_APPROVAL_TO_APPROVER_PREIMBURSEMENT"] = "payment_request_approval_to_approver_preimbursement";
    EmailContentCode["PAYMENT_REQUEST_REPLIED_INFO_NEEDED_TO_APPROVER_PREIMBURSEMENT"] = "payment_request_replied_info_needed_to_approver_preimbursement";
    EmailContentCode["DOCUMENTATION_REMINDER_FOR_PAYMENT"] = "documentation_reminder_for_payment";
    EmailContentCode["DOCUMENTATION_REMINDER_FOR_PREIMBURSEMENT"] = "documentation_reminder_for_preimbursement";
    // Termination
    EmailContentCode["EMPLOYEE_TERMINATION"] = "employee_termination";
    EmailContentCode["EXPORT_COMPLETED"] = "export_completed";
    EmailContentCode["EXPORT_NO_FILE_SENT"] = "export_no_file_sent";
})(EmailContentCode || (EmailContentCode = {}));
export var WebpageContentCode;
(function (WebpageContentCode) {
    WebpageContentCode["EMPLOYEE_HOME"] = "employee_home";
    WebpageContentCode["EMPLOYEE_APPLY"] = "employee_apply";
    WebpageContentCode["REIMBURSEMENT_POLICY"] = "reimbursement_policy";
})(WebpageContentCode || (WebpageContentCode = {}));
export var MinReqGradeType;
(function (MinReqGradeType) {
    MinReqGradeType["A_PLUS"] = "a_plus";
    MinReqGradeType["A"] = "a";
    MinReqGradeType["A_MINUS"] = "a_minus";
    MinReqGradeType["B_PLUS"] = "b_plus";
    MinReqGradeType["B"] = "b";
    MinReqGradeType["B_MINUS"] = "b_minus";
    MinReqGradeType["C_PLUS"] = "c_plus";
    MinReqGradeType["C"] = "c";
    MinReqGradeType["C_MINUS"] = "c_minus";
    MinReqGradeType["D_PLUS"] = "d_plus";
    MinReqGradeType["D"] = "d";
    MinReqGradeType["D_MINUS"] = "d_minus";
})(MinReqGradeType || (MinReqGradeType = {}));
export var GradeType;
(function (GradeType) {
    GradeType["A_PLUS"] = "a_plus";
    GradeType["A"] = "a";
    GradeType["A_MINUS"] = "a_minus";
    GradeType["B_PLUS"] = "b_plus";
    GradeType["B"] = "b";
    GradeType["B_MINUS"] = "b_minus";
    GradeType["C_PLUS"] = "c_plus";
    GradeType["C"] = "c";
    GradeType["C_MINUS"] = "c_minus";
    GradeType["D_PLUS"] = "d_plus";
    GradeType["D"] = "d";
    GradeType["D_MINUS"] = "d_minus";
    GradeType["F"] = "f";
    GradeType["DID_NOT_ENROLL"] = "did_not_enroll";
    GradeType["DROPPED"] = "dropped";
    GradeType["FAIL"] = "fail";
    GradeType["INCOMPLETE"] = "incomplete";
    GradeType["PASS"] = "pass";
    GradeType["SATISFACTORY"] = "satisfactory";
    GradeType["UNSATISFACTORY"] = "unsatisfactory";
})(GradeType || (GradeType = {}));
export var GradeTypeSubset;
(function (GradeTypeSubset) {
    GradeTypeSubset["A_PLUS"] = "a_plus";
    GradeTypeSubset["A"] = "a";
    GradeTypeSubset["A_MINUS"] = "a_minus";
    GradeTypeSubset["B_PLUS"] = "b_plus";
    GradeTypeSubset["B"] = "b";
    GradeTypeSubset["B_MINUS"] = "b_minus";
    GradeTypeSubset["C_PLUS"] = "c_plus";
    GradeTypeSubset["C"] = "c";
    GradeTypeSubset["C_MINUS"] = "c_minus";
    GradeTypeSubset["D_PLUS"] = "d_plus";
    GradeTypeSubset["D"] = "d";
    GradeTypeSubset["D_MINUS"] = "d_minus";
    GradeTypeSubset["F"] = "f";
})(GradeTypeSubset || (GradeTypeSubset = {}));
export var ProgramStatus;
(function (ProgramStatus) {
    ProgramStatus["INFO_REQUESTED"] = "INFO_REQUESTED";
    ProgramStatus["PENDING"] = "PENDING";
    ProgramStatus["IN_REVIEW"] = "IN_REVIEW";
    ProgramStatus["CANCELLED"] = "CANCELLED";
    ProgramStatus["REJECTED"] = "REJECTED";
    ProgramStatus["ACTIVE"] = "ACTIVE";
    ProgramStatus["CHANGE_PENDING"] = "CHANGE_PENDING";
    ProgramStatus["ON_HOLD"] = "ON_HOLD";
    ProgramStatus["CLOSED"] = "CLOSED";
})(ProgramStatus || (ProgramStatus = {}));
export var PaymentRequestStatus;
(function (PaymentRequestStatus) {
    PaymentRequestStatus["INFO_REQUESTED"] = "INFO_REQUESTED";
    PaymentRequestStatus["PENDING"] = "PENDING";
    PaymentRequestStatus["IN_REVIEW"] = "IN_REVIEW";
    PaymentRequestStatus["CANCELLED"] = "CANCELLED";
    PaymentRequestStatus["REJECTED"] = "REJECTED";
    PaymentRequestStatus["ACTIVE"] = "ACTIVE";
    PaymentRequestStatus["DOCUMENT_REVIEW"] = "DOCUMENT_REVIEW";
    PaymentRequestStatus["APPROVED"] = "APPROVED";
    PaymentRequestStatus["READY_FOR_PAYMENT"] = "READY_FOR_PAYMENT";
    PaymentRequestStatus["CLOSED"] = "CLOSED";
    PaymentRequestStatus["ON_HOLD"] = "ON_HOLD";
    PaymentRequestStatus["EXPIRED"] = "EXPIRED";
    PaymentRequestStatus["AWAITING_DOCUMENTS"] = "AWAITING_DOCUMENTS";
})(PaymentRequestStatus || (PaymentRequestStatus = {}));
export var PreimbursementStatus;
(function (PreimbursementStatus) {
    PreimbursementStatus["VERIFIED"] = "VERIFIED";
    PreimbursementStatus["PENDING_PROOF"] = "PENDING_PROOF";
    PreimbursementStatus["SUBMITTED_PROOF"] = "SUBMITTED_PROOF";
    PreimbursementStatus["VERIFIED_PROOF"] = "VERIFIED_PROOF";
    PreimbursementStatus["COMPLETED_POSITIVE"] = "COMPLETED_POSITIVE";
    PreimbursementStatus["COMPLETED_NEGATIVE"] = "COMPLETED_NEGATIVE";
})(PreimbursementStatus || (PreimbursementStatus = {}));
export var PaymentMethod;
(function (PaymentMethod) {
    PaymentMethod["REIMBURSEMENT"] = "REIMBURSEMENT";
    PaymentMethod["PREIMBURSEMENT"] = "PREIMBURSEMENT";
})(PaymentMethod || (PaymentMethod = {}));
export var PaymentRequestItemStatus;
(function (PaymentRequestItemStatus) {
    PaymentRequestItemStatus["PENDING"] = "PENDING";
    PaymentRequestItemStatus["EXCEEDS_LIMIT"] = "EXCEEDS_LIMIT";
    PaymentRequestItemStatus["FULLY_APPROVED"] = "FULLY_APPROVED";
    PaymentRequestItemStatus["PARTIALLY_APPROVED"] = "PARTIALLY_APPROVED";
    PaymentRequestItemStatus["REJECTED"] = "REJECTED";
    PaymentRequestItemStatus["INADEQUATE_GRADE"] = "INADEQUATE_GRADE";
    PaymentRequestItemStatus["EXPIRED"] = "EXPIRED";
    PaymentRequestItemStatus["REVOKED"] = "REVOKED";
    PaymentRequestItemStatus["CANCELLED"] = "CANCELLED";
    PaymentRequestItemStatus["FULL_SCHOLARSHIP"] = "FULL_SCHOLARSHIP";
    PaymentRequestItemStatus["PARTIAL_SCHOLARSHIP"] = "PARTIAL_SCHOLARSHIP";
})(PaymentRequestItemStatus || (PaymentRequestItemStatus = {}));
export var PaymentRequestItemType;
(function (PaymentRequestItemType) {
    PaymentRequestItemType["COURSE"] = "COURSE";
    PaymentRequestItemType["FEE"] = "FEE";
    PaymentRequestItemType["BOOK"] = "BOOK";
    PaymentRequestItemType["MATERIAL"] = "MATERIAL";
    PaymentRequestItemType["SCHOLARSHIP"] = "SCHOLARSHIP";
})(PaymentRequestItemType || (PaymentRequestItemType = {}));
export const emptyContent = {
    id: 0,
    createdAt: '',
    updatedAt: '',
    clientId: 0,
    contentType: '',
    name: '',
    code: '',
    extraData: {},
};
export const emptyContentItem = {
    id: 0,
    createdAt: '',
    updatedAt: '',
    clientId: 0,
    parentId: 0,
    language: '',
    code: '',
    value: '',
};
export var BenefitPeriodType;
(function (BenefitPeriodType) {
    BenefitPeriodType["TAX_YEAR"] = "TAX_YEAR";
    BenefitPeriodType["CAP_YEAR"] = "CAP_YEAR";
    BenefitPeriodType["BUDGET_YEAR"] = "BUDGET_YEAR";
})(BenefitPeriodType || (BenefitPeriodType = {}));
export var ImportStatus;
(function (ImportStatus) {
    ImportStatus["PENDING"] = "PENDING";
    ImportStatus["RUNNING"] = "RUNNING";
    ImportStatus["COMPLETED"] = "COMPLETED";
    ImportStatus["COMPLETED_WITH_ERRORS"] = "COMPLETED_WITH_ERRORS";
    ImportStatus["NO_FILES_FOUND"] = "NO_FILES_FOUND";
    ImportStatus["ERROR"] = "ERROR";
    ImportStatus["TEST"] = "TEST";
    ImportStatus["QUARANTINE"] = "QUARANTINE";
})(ImportStatus || (ImportStatus = {}));
export const emptyImport = {
    id: 0,
    createdAt: '',
    updatedAt: '',
    clientId: 0,
    name: '',
    integrationConfigId: 0,
    entityType: '',
    isActive: true,
    isPartialFile: true,
    criteria: {
        op: FilterGroupOperator.AND,
        conditions: [],
        groups: [],
    },
    snapshotUsingFilenameDate: false,
    fileDelimiter: ',',
    extraData: {},
};
export var ExportStatus;
(function (ExportStatus) {
    ExportStatus["PENDING"] = "PENDING";
    ExportStatus["RUNNING"] = "RUNNING";
    ExportStatus["COMPLETED"] = "COMPLETED";
    ExportStatus["COMPLETED_WITH_ERRORS"] = "COMPLETED_WITH_ERRORS";
    ExportStatus["ERROR"] = "ERROR";
})(ExportStatus || (ExportStatus = {}));
export const emptyExport = {
    id: 0,
    createdAt: '',
    updatedAt: '',
    clientId: 0,
    name: '',
    integrationConfigId: 0,
    entityType: '',
    isActive: true,
    sendEmptyFile: false,
    notifyNoFileSent: false,
    publicKey: '',
    extension: '',
    shortName: '',
    filenamePattern: '',
    extraData: {
        processAllClients: true,
        childClientIds: [],
    },
};
export var WorkflowTaskType;
(function (WorkflowTaskType) {
    WorkflowTaskType["APPROVAL"] = "APPROVAL";
    WorkflowTaskType["NOTIFICATION"] = "NOTIFICATION";
})(WorkflowTaskType || (WorkflowTaskType = {}));
export var WorkflowTaskTargetUserType;
(function (WorkflowTaskTargetUserType) {
    WorkflowTaskTargetUserType["SUPERVISOR"] = "SUPERVISOR";
    WorkflowTaskTargetUserType["HR_MANAGER"] = "HR_MANAGER";
    WorkflowTaskTargetUserType["DEPT_MANAGER"] = "DEPT_MANAGER";
    WorkflowTaskTargetUserType["HR_VP"] = "HR_VP";
    WorkflowTaskTargetUserType["DIVISION_VP"] = "DIVISION_VP";
    WorkflowTaskTargetUserType["BUSINESS_PRESIDENT"] = "BUSINESS_PRESIDENT";
    WorkflowTaskTargetUserType["CLAIMS_PROCESSOR"] = "CLAIMS_PROCESSOR";
})(WorkflowTaskTargetUserType || (WorkflowTaskTargetUserType = {}));
export var WorkflowRunTaskStatus;
(function (WorkflowRunTaskStatus) {
    WorkflowRunTaskStatus["PENDING"] = "PENDING";
    WorkflowRunTaskStatus["IN_PROGRESS"] = "IN_PROGRESS";
    WorkflowRunTaskStatus["CANCELLED"] = "CANCELLED";
    WorkflowRunTaskStatus["INFO_REQUESTED"] = "INFO_REQUESTED";
    WorkflowRunTaskStatus["APPROVED"] = "APPROVED";
    WorkflowRunTaskStatus["EXPIRED"] = "EXPIRED";
    WorkflowRunTaskStatus["REJECTED"] = "REJECTED";
    WorkflowRunTaskStatus["CLOSED"] = "CLOSED";
})(WorkflowRunTaskStatus || (WorkflowRunTaskStatus = {}));
export var SchoolType;
(function (SchoolType) {
    SchoolType["PUBLIC"] = "PUBLIC";
    SchoolType["PRIVATE_FOR_PROFIT"] = "PRIVATE_FOR_PROFIT";
    SchoolType["PRIVATE_NON_PROFIT"] = "PRIVATE_NON_PROFIT";
})(SchoolType || (SchoolType = {}));
export var SchoolSource;
(function (SchoolSource) {
    SchoolSource["MASTER_LIST"] = "MASTER_LIST";
    SchoolSource["OTHER_SCHOOL_APPROVAL"] = "OTHER_SCHOOL_APPROVAL";
    SchoolSource["CLIENT_PROVIDED"] = "CLIENT_PROVIDED";
})(SchoolSource || (SchoolSource = {}));
export const EmailSections = {
    employees: {
        authentication: [
            EmailContentCode.RESET_PASSWORD,
            EmailContentCode.SIGN_UP,
            EmailContentCode.MFA_CODE,
        ],
        programRequest: [
            EmailContentCode.PROGRAM_APPROVED,
            EmailContentCode.PROGRAM_REJECTED,
            EmailContentCode.PROGRAM_INFO_NEEDED,
            EmailContentCode.PROGRAM_EXPIRED,
        ],
        paymentRequest: [
            EmailContentCode.PAYMENT_REQUEST_APPROVED,
            EmailContentCode.PAYMENT_REQUEST_REJECTED,
            EmailContentCode.PAYMENT_REQUEST_INFO_NEEDED,
            EmailContentCode.PAYMENT_REQUEST_APPROVED_PREIMBURSEMENT,
            EmailContentCode.PAYMENT_REQUEST_REJECTED_PREIMBURSEMENT,
            EmailContentCode.PAYMENT_REQUEST_INFO_NEEDED_PREIMBURSEMENT,
            EmailContentCode.DOCUMENTATION_REMINDER_FOR_PAYMENT,
            EmailContentCode.DOCUMENTATION_REMINDER_FOR_PREIMBURSEMENT,
        ],
        payment: [
            EmailContentCode.PAYMENT_APPROVED,
            EmailContentCode.PAYMENT_REJECTED,
            EmailContentCode.PAYMENT_INFO_NEEDED,
        ],
        termination: [EmailContentCode.EMPLOYEE_TERMINATION],
    },
    approvers: {
        programRequest: [
            EmailContentCode.PROGRAM_APPROVAL_TO_APPROVER,
            EmailContentCode.PROGRAM_REPLIED_INFO_NEEDED_TO_APPROVER,
            EmailContentCode.OTHER_SCHOOL_APPROVAL_TO_APPROVER,
        ],
        paymentRequest: [
            EmailContentCode.PAYMENT_REQUEST_APPROVAL_TO_APPROVER,
            EmailContentCode.PAYMENT_REQUEST_REPLIED_INFO_NEEDED_TO_APPROVER,
            EmailContentCode.PAYMENT_REQUEST_APPROVAL_TO_APPROVER_PREIMBURSEMENT,
            EmailContentCode.PAYMENT_REQUEST_REPLIED_INFO_NEEDED_TO_APPROVER_PREIMBURSEMENT,
        ],
        export: [EmailContentCode.EXPORT_COMPLETED, EmailContentCode.EXPORT_NO_FILE_SENT],
    },
};
export var AttestationType;
(function (AttestationType) {
    AttestationType["PROGRAM"] = "program";
    AttestationType["PAYMENT_REQUEST"] = "payment_request";
    AttestationType["PAYMENT_REQUEST_PREIMBURSEMENT"] = "payment_request_preimbursement";
    AttestationType["PAYMENT_REQUEST_PREIMBURSEMENT_UPLOAD_PROOF"] = "payment_request_preimbursement_upload_proof";
    AttestationType["PAYMENT_REQUEST_PREAPPROVAL"] = "payment_request_preapproval";
})(AttestationType || (AttestationType = {}));
export var NotificationStatus;
(function (NotificationStatus) {
    NotificationStatus["ERROR"] = "ERROR";
    NotificationStatus["PENDING"] = "PENDING";
    NotificationStatus["PROCESSING"] = "PROCESSING";
    NotificationStatus["QUEUED"] = "QUEUED";
    NotificationStatus["SENT"] = "SENT";
})(NotificationStatus || (NotificationStatus = {}));
export var DateRangeFilter;
(function (DateRangeFilter) {
    DateRangeFilter["PAST_7_DAYS"] = "PAST_7_DAYS";
    DateRangeFilter["PAST_90_DAYS"] = "PAST_90_DAYS";
    DateRangeFilter["PAST_YEAR"] = "PAST_YEAR";
})(DateRangeFilter || (DateRangeFilter = {}));
export var ReportType;
(function (ReportType) {
    ReportType["EMPLOYEE"] = "employee";
    ReportType["EMPLOYEE_SPEND"] = "employee_spend";
    ReportType["PROGRAM_SPEND"] = "program_spend";
})(ReportType || (ReportType = {}));
export var ReportStatus;
(function (ReportStatus) {
    ReportStatus["PENDING"] = "PENDING";
    ReportStatus["RUNNING"] = "RUNNING";
    ReportStatus["COMPLETED"] = "COMPLETED";
    ReportStatus["COMPLETED_WITH_ERRORS"] = "COMPLETED_WITH_ERRORS";
    ReportStatus["ERROR"] = "ERROR";
    ReportStatus["TEST"] = "TEST";
})(ReportStatus || (ReportStatus = {}));
export const emptyReportTemplate = {
    id: 0,
    createdAt: '',
    updatedAt: '',
    clientId: 0,
    name: '',
    type: '',
    settings: {
        columns: [],
        spec: {},
    },
    integrationConfigId: 0,
    isActive: true,
    showInDashboard: false,
};
export var ProgramLevelType;
(function (ProgramLevelType) {
    ProgramLevelType["RECURRING"] = "RECURRING";
    ProgramLevelType["SINGLE"] = "SINGLE";
    ProgramLevelType["BOTH"] = "BOTH";
})(ProgramLevelType || (ProgramLevelType = {}));
export var GradingScaleType;
(function (GradingScaleType) {
    GradingScaleType["RANGE"] = "RANGE";
    GradingScaleType["CATEGORY"] = "CATEGORY";
})(GradingScaleType || (GradingScaleType = {}));
export var AccessType;
(function (AccessType) {
    AccessType["EMPLOYEE"] = "EMPLOYEE";
    AccessType["APPROVER"] = "APPROVER";
})(AccessType || (AccessType = {}));
